module.exports = __webpack_public_path__ + "static/hero-text-104306672d0ccc3de0fc96b5e8d4a3c8.svg";